import { useContext, useMemo } from "react";
import { AppContext } from "context/appContext";

const useActiveTenantID = () => {
  const { state } = useContext(AppContext);

  const tenantID = useMemo(() => {
    return state.tenant.id;
  }, [state.tenant.id]);

  return tenantID;
};

export default useActiveTenantID;
